import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

export const UkDateField = ({ value, onChange, testid, placeholder = "Pick a date" }) => {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value) : undefined;
  return (
    <span className="inline-flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid} className="inline-flex items-center gap-2 bg-white border border-[#EBE9E4] rounded-lg px-3 py-1.5 text-sm hover:bg-[#F4F8F6]">
            <CalendarDays className="h-4 w-4" style={{ color: "var(--sj-primary)" }} /> {d ? format(d, "dd/MM/yyyy") : placeholder}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={d} weekStartsOn={1} disabled={{ before: new Date(new Date().setHours(0, 0, 0, 0)) }} onSelect={(x) => { onChange(x ? format(x, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      {value && <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange("")} aria-label="Clear date" className="p-1 rounded-full hover:bg-[#EDF2F4]"><X className="h-3.5 w-3.5" /></button>}
    </span>
  );
};
